// extracted by mini-css-extract-plugin
export default {"loader-container":"Loading_loader-container__5+5NZ","loading-item":"Loading_loading-item__KBFcH","spinner":"Loading_spinner__dEyxg","spin-anim":"Loading_spin-anim__iyMs+"};